import { Box, useTheme } from '@mui/material';
import React from 'react';

import { Main, MainProps } from 'components/atoms/FlexContainers/FlexContainers';

interface Props extends MainProps {
  toolbar: React.ReactNode;
  children: React.ReactNode;
  sidePanel?: React.ReactNode;
  sidePanelWidth?: number | string;
}

export const StudyDashboardTabTableLayout: React.FC<React.PropsWithChildren<Props>> = ({
  toolbar,
  children,
  sidePanel,
  sidePanelWidth,
  useOwnScroll = true,
  ...mainProps
}) => {
  const theme = useTheme();

  return (
    <Main useOwnScroll={useOwnScroll} {...mainProps}>
      <Box
        sx={{
          display: 'flex',
          height: useOwnScroll ? '100%' : 'auto',
          minHeight: useOwnScroll ? 0 : '100%',
          overflow: useOwnScroll ? 'hidden' : 'visible',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
            height: useOwnScroll ? '100%' : 'auto',
            minHeight: 0,
            px: 10,
            pt: 3,
            overflow: useOwnScroll ? 'hidden' : 'visible',
          }}
        >
          <Box
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 2,
              flexShrink: 0,
              pb: 2,
              backgroundColor:
                theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.background.default,
            }}
          >
            {toolbar}
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: useOwnScroll ? 'hidden' : 'visible',
            }}
          >
            {children}
          </Box>
        </Box>
        {sidePanel && (
          <Box
            sx={{
              width: sidePanelWidth,
              maxWidth: sidePanelWidth,
              flexShrink: 0,
              minHeight: 0,
              borderLeft: `1px solid ${
                theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800]
              }`,
              backgroundColor: theme.palette.background.paper,
              boxShadow: theme.shadows[3],
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {sidePanel}
          </Box>
        )}
      </Box>
    </Main>
  );
};
